module.exports = __webpack_public_path__ + "static/media/notfound.f2c43261.png";